/* eslint-disable react/prop-types */
/* react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from '../../atoms/breadcrumb/breadcrumb';
import Title from '../../atoms/title/title';
import './pageTitle.scss';

const PageTitle = (props) => {
  const {
    children,
    userNavigation,
    myEmail,
    lockIcon,
  } = props;

  return (
    <div>
      <Title lockIcon={lockIcon} myEmail={myEmail} userNavigation={userNavigation}>{children}</Title>
      <hr />
    </div>
  );
};

PageTitle.propTypes = {
  children: PropTypes.string.isRequired,
  userNavigation:PropTypes.array
};

export default PageTitle;
